// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__KMPr-","footer":"ModalError_footer__3UO3J"};